import { 
    GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA,
    GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA, 
    GET_UPDATED_BY_ACQUISITION_LIST, 
    SAVE_DISCOUNT_FLAG, 
    SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA, 
    SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA, 
    SET_DISCOUNT_FLAG, 
    SET_UPDATED_BY_ACQUISITION_LIST
} from "./AcquisitionCodeMaintenanceType";

const getAcquisitionCodeMaintenanceGridData = (payload: any) => ({
    type: GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA,
    payload
});

const setAcquisitionCodeMaintenanceGridData = (gridData: any) => ({
    type: SET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA,
    gridData
});

const getUpdatedByAcquisitionList = () => ({
    type: GET_UPDATED_BY_ACQUISITION_LIST
});

const setUpdatedByAcquisitionList = (dropdownList: any) => ({
    type: SET_UPDATED_BY_ACQUISITION_LIST,
    dropdownList
});

const saveDiscountFlag = (payload: any) => ({
    type: SAVE_DISCOUNT_FLAG,
    payload
})

const setDiscountFlag = (flag: any) => ({
    type: SET_DISCOUNT_FLAG,
    flag
})

const getAcquisitionCodeMaintenanceExcelData = (payload: any) => ({
    type: GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA,
    payload
})

const setAcquisitionCodeMaintenanceExcelData = (excelData: any) => ({
    type: SET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA,
    excelData
})

export {
    getAcquisitionCodeMaintenanceGridData,
    setAcquisitionCodeMaintenanceGridData,
    getUpdatedByAcquisitionList,
    setUpdatedByAcquisitionList,
    saveDiscountFlag,
    setDiscountFlag,
    getAcquisitionCodeMaintenanceExcelData,
    setAcquisitionCodeMaintenanceExcelData
}
